require("core-js/modules/es6.object.define-property");

var $CLJS = require("./cljs_env");

var $jscomp = $CLJS.$jscomp;
var COMPILED = false;

require("./cljs.core.js");

require("./cljs.spec.alpha.js");

require("./com.fulcrologic.guardrails.core.js");

require("./com.wsscode.pathom3.path.js");

var edn_query_language = $CLJS.edn_query_language || ($CLJS.edn_query_language = {});
var module$shadow_js_shim_module$react = $CLJS.module$shadow_js_shim_module$react || ($CLJS.module$shadow_js_shim_module$react = {});
var clojure = $CLJS.clojure || ($CLJS.clojure = {});
var cljs = $CLJS.cljs || ($CLJS.cljs = {});
var shadow = $CLJS.shadow || ($CLJS.shadow = {});
var module$shadow_js_shim_module$react_dom = $CLJS.module$shadow_js_shim_module$react_dom || ($CLJS.module$shadow_js_shim_module$react_dom = {});
var helix = $CLJS.helix || ($CLJS.helix = {});
var goog = $CLJS.goog || ($CLJS.goog = {});
var module$shadow_js_shim_module$$nivo$line = $CLJS.module$shadow_js_shim_module$$nivo$line || ($CLJS.module$shadow_js_shim_module$$nivo$line = {});
var expound = $CLJS.expound || ($CLJS.expound = {});
var module$shadow_js_shim_module$$nivo$bar = $CLJS.module$shadow_js_shim_module$$nivo$bar || ($CLJS.module$shadow_js_shim_module$$nivo$bar = {});
var cljs_bean = $CLJS.cljs_bean || ($CLJS.cljs_bean = {});
var promesa = $CLJS.promesa || ($CLJS.promesa = {});
var com = $CLJS.com || ($CLJS.com = {});
$CLJS.SHADOW_ENV.setLoaded("com.wsscode.pathom3.placeholder.js");
goog.provide('com.wsscode.pathom3.placeholder');
cljs.spec.alpha.def_impl(new cljs.core.Keyword("com.wsscode.pathom3.placeholder", "placeholder-prefixes", "com.wsscode.pathom3.placeholder/placeholder-prefixes", -1875287531), cljs.core.list(new cljs.core.Symbol("cljs.spec.alpha", "coll-of", "cljs.spec.alpha/coll-of", 1019430407, null), new cljs.core.Symbol("cljs.core", "string?", "cljs.core/string?", -2072921719, null), new cljs.core.Keyword(null, "kind", "kind", -717265803), new cljs.core.Symbol("cljs.core", "set?", "cljs.core/set?", -1176684971, null)), cljs.spec.alpha.every_impl.cljs$core$IFn$_invoke$arity$4(new cljs.core.Symbol(null, "string?", "string?", -1129175764, null), cljs.core.string_QMARK_, new cljs.core.PersistentArrayMap(null, 5, [new cljs.core.Keyword("cljs.spec.alpha", "conform-all", "cljs.spec.alpha/conform-all", 45201917), true, new cljs.core.Keyword(null, "kind", "kind", -717265803), cljs.core.set_QMARK_, new cljs.core.Keyword("cljs.spec.alpha", "kind-form", "cljs.spec.alpha/kind-form", -1047104697), new cljs.core.Symbol("cljs.core", "set?", "cljs.core/set?", -1176684971, null), new cljs.core.Keyword("cljs.spec.alpha", "describe", "cljs.spec.alpha/describe", 1883026911), cljs.core.list(new cljs.core.Symbol("cljs.spec.alpha", "coll-of", "cljs.spec.alpha/coll-of", 1019430407, null), new cljs.core.Symbol("cljs.core", "string?", "cljs.core/string?", -2072921719, null), new cljs.core.Keyword(null, "kind", "kind", -717265803), new cljs.core.Symbol("cljs.core", "set?", "cljs.core/set?", -1176684971, null)), new cljs.core.Keyword("cljs.spec.alpha", "cpred", "cljs.spec.alpha/cpred", -693471218), function (G__34910) {
  return cljs.core.set_QMARK_(G__34910);
}], null), null));
/**
 * Check if a given key is a placeholder.
 */

com.wsscode.pathom3.placeholder.placeholder_key_QMARK_ = function com$wsscode$pathom3$placeholder$placeholder_key_QMARK_(p__34911, k) {
  var map__34912 = p__34911;
  var map__34912__$1 = (!(map__34912 == null) ? map__34912.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34912.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34912) : map__34912;
  var placeholder_prefixes = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34912__$1, new cljs.core.Keyword("com.wsscode.pathom3.path", "placeholder-prefixes", "com.wsscode.pathom3.path/placeholder-prefixes", 77896209));

  var placeholder_prefixes__$1 = function () {
    var or__4126__auto__ = placeholder_prefixes;

    if (cljs.core.truth_(or__4126__auto__)) {
      return or__4126__auto__;
    } else {
      return new cljs.core.PersistentHashSet(null, new cljs.core.PersistentArrayMap(null, 1, [">", null], null), null);
    }
  }();

  return k instanceof cljs.core.Keyword && cljs.core.contains_QMARK_(placeholder_prefixes__$1, cljs.core.namespace(k));
};
/**
 * Find the closest parent key that's not a placeholder key.
 */


com.wsscode.pathom3.placeholder.find_closest_non_placeholder_parent_join_key = function com$wsscode$pathom3$placeholder$find_closest_non_placeholder_parent_join_key(p__34915) {
  var map__34916 = p__34915;
  var map__34916__$1 = (!(map__34916 == null) ? map__34916.cljs$lang$protocol_mask$partition0$ & 64 || cljs.core.PROTOCOL_SENTINEL === map__34916.cljs$core$ISeq$ ? true : false : false) ? cljs.core.apply.cljs$core$IFn$_invoke$arity$2(cljs.core.hash_map, map__34916) : map__34916;
  var env = map__34916__$1;
  var path = cljs.core.get.cljs$core$IFn$_invoke$arity$2(map__34916__$1, new cljs.core.Keyword("com.wsscode.pathom3.path", "path", "com.wsscode.pathom3.path/path", 1029673558));
  return cljs.core.first(cljs.core.remove.cljs$core$IFn$_invoke$arity$2(function (p1__34914_SHARP_) {
    return com.wsscode.pathom3.placeholder.placeholder_key_QMARK_(env, p1__34914_SHARP_);
  }, cljs.core.drop.cljs$core$IFn$_invoke$arity$2(1, cljs.core.rseq(function () {
    var or__4126__auto__ = path;

    if (cljs.core.truth_(or__4126__auto__)) {
      return or__4126__auto__;
    } else {
      return cljs.core.PersistentVector.EMPTY;
    }
  }()))));
};

Object.defineProperty(module.exports, "placeholder_key_QMARK_", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.placeholder.placeholder_key_QMARK_;
  }
});
Object.defineProperty(module.exports, "find_closest_non_placeholder_parent_join_key", {
  enumerable: false,
  get: function get() {
    return com.wsscode.pathom3.placeholder.find_closest_non_placeholder_parent_join_key;
  }
});